import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";
import {SalesPointSaleComponent} from "./sales-point-sale.component";
import { SalesClaroCredibancoComponent } from './claro-credibanco/sales-claro-credibanco.component';
import { SalesExitoEvertecComponent } from './exito-evertec/sales-exito-evertec.component';
import {GeneralModule} from "../general/general.module";



@NgModule({
  declarations: [
    SalesPointSaleComponent,
    SalesClaroCredibancoComponent,
    SalesExitoEvertecComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule,
    GeneralModule
  ],
  exports: [
    SalesPointSaleComponent
  ]
})
export class SalesPointSaleModule { }
